<template>
    <span id="audioPlayerComponent"></span>
</template>

<script>
    import axios from "axios";
    import moment from "moment";
    export default {
        data() {
            return {
                volumeOn: true,
                profile: null,
                useClient: false,
                queue: [],
                soundPlaying: false,
                volume: 0.5,
                welcomePlayed: false,
                clientQueue: [],
            }
        },
        mounted() {
            this.profile = window.currentProfile ? window.currentProfile.sounds : 1;
            this.useClient = window.currentProfile ? !window.currentProfile.use_website_sounds : false;
            this.volumeOn = localStorage.getItem('volumeOn') !== null ? JSON.parse(localStorage.getItem('volumeOn')) : true;
            this.volume = window.currentProfile ? parseInt(window.currentProfile.volume) / 100 : 0.5;

            if (window.name != "top") {
                window.connection.subscribe(this);
                this.update(window.connection.lastUpdate);
            }
        },
        methods: {
            update(data) {
                if (data == null) return;

                this.volumeOn = localStorage.getItem('volumeOn') !== null ? JSON.parse(localStorage.getItem('volumeOn')) : true;
                if (this.volumeOn === false) return;
                if (this.profile > 2) return; //do not use caller sounds

                if (data.gameState.winner != null && !data.action) return; //don't play any sounds if the game is finished and action is loading the game
                if (data.gameState.audiofiles) {
                    this.volumeOn = localStorage.getItem('volumeOn') !== null ? JSON.parse(localStorage.getItem('volumeOn')) : true;
                    if (this.volumeOn === false) return;
                    if (!this.welcomePlayed) {
                        this.welcomePlayed = true;
                        this.addAudioFile("welcome"); //will only be played once per day
                    }
                    data.gameState.audiofiles.forEach(audio => {
                        if (audio.typ == 'score') {
                            this.addAudioScore(audio.file);
                        } else if (audio.typ == 'command' && (audio.user == window.logged_in_user || audio.user == null)) {
                            this.addAudioFile(audio.file)
                        } else
                            this.addAudioFile(audio.file)
                    });
                    this.playNext(); //play queue
                }
            },
            addAudioScore(file) {
                var score = parseInt(file.split("_")[1]);
                var currentAudioFile = score < 100 ? score < 10 ? '00' + score : '0' + score : score;
                // if (currentAudioFile == "000") currentAudioFile = "0";
                this.queue.push([file, 'Caller ' + currentAudioFile]);
            },
            playAudio(score) {
                if (score == undefined) return;
                this.volumeOn = localStorage.getItem('volumeOn') !== null ? JSON.parse(localStorage.getItem('volumeOn')) : true;
                if (this.volumeOn === false) return;
                if (this.profile > 2) return; //do not use caller sounds
                var currentAudioFile = score < 100 ? score < 10 ? '00' + score : '0' + score : score;
                if (currentAudioFile == "000") currentAudioFile = "0";
                if (this.useClient) {
                    this.sendClientEvent("Caller " + currentAudioFile)
                } else {
                    this.addToQueue('caller-caller_'+score);
                }
            },
            playAudioTripple(number) {
                if (this.profile != 1 && this.profile != 3) return; //do not use sound effects
                if (this.useClient) {
                    this.sendClientEvent("Triple " + number)
                } else {
                    this.addToQueue('DBO-dbo_triple'+number);
                }
            },
            addAudioFile(f) {
                if (this.profile != 1 && this.profile != 3) return; //do not use sound effects
                var soundname = "";
                if (f.indexOf("triple") != -1) {
                    var f_temp = f+"";
                    f = "dbo_" + f_temp;
                    soundname = "Triple " + f_temp.split("triple")[1];
                }
                if (f.indexOf("bullseye") != -1) {
                    var f_temp = f+"";
                    f = "dbo_dbull";
                    soundname = "Bulls Eye";
                }
                if (f == "beep1") {
                    f = "dbo_upbeep";
                    soundname = "Anfang Runde"
                }
                if (f == "beep2") {
                    f = "dbo_downbeep";
                    soundname = "Ende Runde";
                }
                if (f == "win") {
                    f = "dbo_winner";
                    soundname = "Spielende";
                }
                if (f == "welcome") {
                    //only play welcome once per day
                    var welcomeDate = localStorage.getItem('lastWelcomePlay')
                    if (!welcomeDate || moment().diff(moment(welcomeDate, "x"), 'hours') >= 24) {
                        f = "dbo_welcome";
                        soundname = "Willkommen";
                        localStorage.setItem('lastWelcomePlay', Date.now())
                    } else {
                        f = null;
                    }
                }
                if (f == "startofgame") {
                    f = "dbo_gameon";
                    soundname = "Spielanfang";
                }
                if (f == "endofleg") {
                    f = "dbo_gameshot";
                    soundname = "GameShot";
                }
                if (f == "endofgame") {
                    f = "dbo_gameshotandthematch";
                    soundname = "Spielende";
                }
                if (f == "dbull") {
                    f = "dbo_dbull";
                    soundname = "Bulls Eye"
                }
                if (f == "miss") {
                    f = "dbo_miss";
                    soundname = "Fehlwurf"
                }
                if (f == "hit") {
                    f = "dbo_hit";
                    soundname = "Treffer"
                }
                if (f == "hit2") {
                    f = "dbo_hit2";
                    soundname = "Treffer2"
                }
                if (f == "hit3") {
                    f = "dbo_hit3";
                    soundname = "Treffer3"
                }
                // if (soundname != '') {
                //     if (this.useClient) {
                //         this.sendClientEvent(soundname);
                //     } else {
                //         this.addToQueue('DBO-'+f);
                //     }
                // }
                if (f != null)
                    this.queue.push(['DBO-'+f, soundname]);
            },
            audioVolumeOn() {
                return this.volumeOn;
            },
            toggleAudioVolume() {
                this.volumeOn = !this.volumeOn;
                localStorage.setItem('volumeOn', this.volumeOn);
            },
            addToQueue(file) {
                console.log(file);
                this.queue.push(file)
                if (!this.soundPlaying) this.playNext();
            },
            playNext() {
                if (this.queue.length == 0 || this.soundPlaying ) return;
                else {
                    if (this.useClient) {
                        while (this.queue.length > 0) {
                            let file = this.queue.shift();
                            this.clientQueue.push(file[1]);
                            if (this.queue.length == 0) {
                                this.sendClientEvent(this.clientQueue)
                                this.playNext();
                                this.clientQueue = [];
                            }
                        }
                    } else {
                        let file = this.queue.shift();
                        this.play(file[0]);
                    }
                }
            },
            play(file) {
                if (this.volumeOn === false) return;
                var element = new Audio('/audio/getfile/' + file);
                element.volume = this.volume;
                element.play().catch(e => {
                    console.log("Could not play sound yet.", e.message);
                    this.soundPlaying = false;
                    this.playNext();
                })
                this.soundPlaying = true;

                element.addEventListener("ended", (e) => {
                    this.soundPlaying = false;
                    this.playNext();
                })

            },
            sendClientEvent(file) {
                axios.post("/games/sendsound", {file: file});
            }
        }
    }
</script>
